const buildFilterArray = function(searchParams, ignoredParamNames){
    const filters = []

    if (!searchParams) return

    for (const [rawParamName] of searchParams.entries()) {
        const paramName = rawParamName.replace('[]','')

        if (!ignoredParamNames.includes(paramName)) {
            filters.push({
                name: paramName,
                facets: []
            })
        }

        ignoredParamNames.push(paramName)
    }

    for (const [rawParamName, paramValue] of searchParams.entries()) {
        const paramName = rawParamName.replace('[]','')

        filters.forEach(filter => {
            if(filter.name === paramName) filter.facets.push({
                name: paramValue,
                selected: true
            })
        })
    }

    return filters
}

const getParameter = function(searchParams, parameterName){
    if (!searchParams || !searchParams.has(parameterName)) return

    return searchParams.get(parameterName)
}

export default function(context, config){
    const rawSearchString = (config && config.searchString) ? config.searchString : location.search
    const normalizedSearchString = rawSearchString.startsWith('?')
        ? rawSearchString.slice(1)
        : rawSearchString
    const searchParams = new URLSearchParams(normalizedSearchString)

    if (!normalizedSearchString) {
        context.dispatch('performSearch')
        return
    }

    const ignoredParamNames = ['pageSize','sortBy','skip','take','q']
    const filters = buildFilterArray(searchParams, ignoredParamNames)
    const sortOption = getParameter(searchParams, 'sortBy')
    const take = getParameter(searchParams, 'take')
    const textSearch = getParameter(searchParams, 'q')
    const shouldApplyUrlSort = !context.state.page_data.isSearchPage

    if(sortOption && shouldApplyUrlSort) context.commit('set_new_sorting',{value: sortOption})
    if(take) context.commit('set_take',take ? take : context.state.default_take)
    if(textSearch) context.commit('set_search_string',textSearch)
    context.commit('set_filters',filters)

    context.dispatch('performSearch')
    context.commit('reset_take_to_default')
}
